import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import _styled from "@emotion/styled-base";
import { css } from '@emotion/core';

var getBgColor = function getBgColor(_ref2) {
  var type = _ref2.type;

  switch (type) {
    case 'info':
      return 'rgba(56, 132, 255, .1)';

    case 'success':
      return 'rgba(0, 219, 136, .1)';

    case 'warning':
      return 'rgba(255, 204, 0, .1)';

    case 'danger':
      return 'rgba(243, 32, 19, .1)';

    default:
      return 'rgba(0, 0, 0, .04)';
  }
};

var getColor = function getColor(_ref3) {
  var type = _ref3.type;

  switch (type) {
    case 'info':
      return 'rgb(56, 132, 255)';

    case 'success':
      return 'rgb(0, 204, 136)';

    case 'warning':
      return 'rgb(255, 204, 0)';

    case 'danger':
      return 'rgb(243, 32, 19)';

    default:
      return 'rgb(0, 0, 0, .3)';
  }
};

var getIcon = function getIcon(_ref4) {
  var type = _ref4.type;

  switch (type) {
    case 'info':
      return 'i';

    case 'success':
      return '✓';

    case 'warning':
      return '!';

    case 'danger':
      return '✖';

    default:
      return 'i';
  }
};

var iconStyles = function iconStyles(_ref5) {
  var icon = _ref5.icon,
      type = _ref5.type;
  return icon && /*#__PURE__*/css("content:'", getIcon({
    type: type
  }), "';position:absolute;font-family:sans-serif;width:22px;height:22px;border:solid 2px ", getColor({
    type: type
  }), ";border-radius:50%;font-size:18px;font-weight:bold;line-height:23px;color:", getColor({
    type: type
  }), ";text-align:center;");
};

export var Container = _styled("div", {
  target: "e5nd6wy0"
})("position:relative;margin:2rem 0;padding:1.25rem 1rem;background-color:", getBgColor, ";border:0;border-style:solid;border-color:", getColor, ";border-left-width:4px;border-radius:3px;");

if (typeof Container !== 'undefined' && Container && Container === Object(Container) && Object.isExtensible(Container) && !Container.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Container, '__filemeta', {
    configurable: true,
    value: {
      name: "Container",
      filename: "node_modules/@nejcm/docz-theme-extended/src/components/Hint/styles.js"
    }
  });
}

var _ref = {
  name: "1tfdn99",
  styles: "top:1.25rem;left:1rem;"
};
export var Inner = /*#__PURE__*/_styled(Container, {
  target: "e5nd6wy1"
})("padding-left:", function (_ref6) {
  var icon = _ref6.icon;
  return icon && '3.5rem';
}, ";&:before{", iconStyles, ";", function (_ref7) {
  var icon = _ref7.icon;
  return icon && _ref;
}, "}");

if (typeof Inner !== 'undefined' && Inner && Inner === Object(Inner) && Object.isExtensible(Inner) && !Inner.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Inner, '__filemeta', {
    configurable: true,
    value: {
      name: "Inner",
      filename: "node_modules/@nejcm/docz-theme-extended/src/components/Hint/styles.js"
    }
  });
}

export var Outer = /*#__PURE__*/_styled(Container, {
  target: "e5nd6wy2"
})("padding-left:", function (_ref8) {
  var icon = _ref8.icon;
  return icon && '1.5rem';
}, ";&:before{", iconStyles, ";", function (_ref9) {
  var icon = _ref9.icon,
      theme = _ref9.theme;
  return icon && /*#__PURE__*/css("top:-14px;left:-14px;background-color:", theme.colors.background, ";box-shadow:0 0 0 9px ", theme.colors.background, ";");
}, "}");

if (typeof Outer !== 'undefined' && Outer && Outer === Object(Outer) && Object.isExtensible(Outer) && !Outer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Outer, '__filemeta', {
    configurable: true,
    value: {
      name: "Outer",
      filename: "node_modules/@nejcm/docz-theme-extended/src/components/Hint/styles.js"
    }
  });
}